import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DashboardService {

    getEventRoute = '/api/newevents/';

    constructor(private dataService: DataService) {
    };

    // getDashboard(districtId, blockId, villageId, date, isleastblock, refresh: boolean) {
    //     return this.dataService.getData('/api/dashboardchart/'
    //         + districtId + '/' + blockId
    //         + '/' + villageId + '/' + date + '/' + isleastblock, refresh);
    // }
    getDashboard(data, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboardbarchart/' + data.districtId + '/' + data.blockId, refresh);
    }

    getDashBoardData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/dashboardchart/' + data.districtId + '/' + data.blockId + '/' + data.sectorId, refresh);
    }

    getMapData(refresh: boolean, districtId, blockId, sectorId, awcId, malNutritionType) {
        return this.dataService.getData('/api/dashboard/mapdata/' + districtId + '/' + blockId + '/' + sectorId + '/' + awcId + '/' + malNutritionType, refresh);
    }

    getMapGeoJsonData(refresh: boolean, districtId, blockId, sectorId, awcId, malNutritionType) {
        return this.dataService.getData('/api/dashboard/mapgeojsondata/' + districtId + '/' + blockId + '/' + sectorId + '/' + awcId + '/' + malNutritionType, refresh);
    }

    getAllDashboardData(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboarddata/' + data.districtId + '/' + data.blockId + '/' + data.sectorId, refresh);
    }

    getMapGridData(refresh: boolean, districtId, blockId, sectorId, severityType) {
        return this.dataService.getData('/api/dashboard/mapgriddata/' + districtId + '/' + blockId + '/' + sectorId + '/' + severityType, refresh);
    }

    getPlannedActualAdditionalDatas(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/mitargetactual/' + data.districtId + '/' + data.blockId, refresh);
    }

    getMiAgegroup(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/miagegroup/' + data.districtId + '/' + data.blockId, refresh);
    }

    getGauageChartData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/dashboard/migaugedata/' + data.districtId + '/' + data.blockId, refresh);
    }

    getMiTreatmentChartData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/report/mimediacaltreatment/' + data.districtId + '/' + data.blockId, refresh);
    }

    getmedicalIntervention(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/child/mi/' + data.beneficiaryId, refresh);
    }

    getmiEvaluation(data: any, refresh: boolean) {
        return this.dataService.getData('/api/child/mi/evaluationdetail/' + data.beneficiaryId, refresh);
    }

    getmedicalInterventionList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/child/awc/' + data.awcId, refresh);
    }

    getAliveStatus(refresh: boolean) {
        return this.dataService.getData('/api/lookup/alivestatustype', refresh);
    }

    getDeathStatus(refresh: boolean) {
        return this.dataService.getData('/api/lookup/deceasedcausetype', refresh);
    }

    getbeneficiarystatushistory(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/beneficiarystatushistory/' + data.beneficiaryId, refresh);
    }

    getLastEntrydateofchild(data: any, refresh: boolean) {
        return this.dataService.getData('/api/beneficiarystatushistory/lastinspection/' + data.beneficiaryId, refresh);
    }

    beneficiaryStatusSave(result: any) {
        return this.dataService.post('/api/beneficiarystatushistory', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getDashboardData(districtId: any, blockId: any, date: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/' + districtId + '/' + blockId + '/' + date, refresh);
    }

    getDistrictWiseBeneficiaryData(eventType: any, areatType: any, districtId: any, blockId: any, municipalityId: any, date: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/districtwiselist/' + eventType + '/' + areatType + '/' + districtId + '/' + blockId + '/' + municipalityId + '/' + date, refresh);
    }

    getDistrictWiseData(districtId: any, blockId: any, date: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/eventstatus/' + districtId + '/' + blockId + '/' + date, refresh);
    }

    // getSchoolsData(districtId: any, blockId: any, municipalityId: any, villagepanchayatId: any, zoneId: any, cookingCenterId: any, eventType, areaType: any, langType: any, date: any, refresh: boolean) {
    //     return this.dataService.getData('/api/school/schoollistbyprogress/' + districtId + '/' + blockId + '/' + municipalityId + '/' + villagepanchayatId + '/' + zoneId + '/' + cookingCenterId + '/' + eventType + '/' + areaType + '/' + langType + '/' + date, refresh);
    // }

    getSchoolsData(result: any) {
        return this.dataService.post('/api/school/schoollistbyprogress', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getHeatmapData(selectedDate: Date, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/heatmap/' + selectedDate, refresh)
    }

    getSchoolEventTimeline(schoolId: any, langType: any, date: any,refresh:boolean) {
        return this.dataService.getData('/api/event/' + schoolId + '/' + langType + '/' + date, refresh)
    }
    getCookingCenterEventTimeLine(cookingCenterId: any, langType: any, date: any,refresh:boolean){
        return this.dataService.getData('/api/cookingcenter/timelinecookingcenterevent/' + cookingCenterId + '/' + langType + '/' + date,refresh); 
        // return this.dataService.getData('/api/cookingcenter/timelinecookingcenterevent/'+ cookingCenterId +'/'+{langType}/{date})
    }
}


//'/api/dashboard/districtwiselist/{eventType}/{areatType}/ {districtId}/ {blockId}/ {municipalityId}/ {date}'